import styled from 'styled-components'

export const Container = styled.div`
  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    left: -4rem;
    height: 100%;
    width: calc(100% + 8rem);
    background: linear-gradient(to bottom, rgba(46, 76, 230, 0.8) 0%, rgba(46, 76, 230, 0.8) 88%, #fcfcfc 100%);
    z-index: 0;
  }
`

export const Title = styled(({ selected, innerRef, ...props }) => (
  <div {...props} ref={innerRef} />
))`
  opacity: ${({ selected }) => (selected ? 0 : 1)};
`
export const LargeTitle = styled(({ selected, innerRef, ...props }) => (
  <div {...props} ref={innerRef} />
))`
  opacity: ${({ selected }) => (selected ? 1 : 0)};
`
